// Countries that we support for Marketplace Payments
// @see https://stripe.com/docs/connect/cross-border-payouts#supported-countries
export const STRIPE_CONNECT_SUPPORTED_COUNTRIES = [
  {name: 'Albania', code: 'AL'},
  {name: 'Algeria', code: 'DZ'},
  {name: 'Australia', code: 'AU'},
  {name: 'Austria', code: 'AT'},
  {name: 'Bangladesh', code: 'BD'},
  {name: 'Belgium', code: 'BE'},
  {name: 'Bulgaria', code: 'BG'},
  {name: 'Canada', code: 'CA'},
  {name: 'Colombia', code: 'CO'},
  {name: 'Croatia', code: 'HR'},
  {name: 'Cyprus', code: 'CY'},
  {name: 'Czech Republic', code: 'CZ'},
  {name: 'Denmark', code: 'DK'},
  {name: 'Ecuador', code: 'EC'},
  {name: 'Egypt', code: 'EG'},
  {name: 'Estonia', code: 'EE'},
  {name: 'Finland', code: 'FI'},
  {name: 'France', code: 'FR'},
  {name: 'Germany', code: 'DE'},
  {name: 'Hungary', code: 'HU'},
  {name: 'Hong Kong', code: 'HK'},
  // disabled temporarily until Stripe fix their bug: https://webflow.atlassian.net/browse/MRKPL-2410
  // {name: 'India', code: 'IN'},
  {name: 'Indonesia', code: 'ID'},
  {name: 'Ireland', code: 'IE'},
  {name: 'Israel', code: 'IL'},
  {name: 'Italy', code: 'IT'},
  {name: 'Japan', code: 'JP'},
  {name: 'Kenya', code: 'KE'},
  {name: 'Latvia', code: 'LV'},
  {name: 'Lithuania', code: 'LT'},
  {name: 'Malaysia', code: 'MY'},
  {name: 'Mexico', code: 'MX'},
  {name: 'Namibia', code: 'NA'},
  {name: 'Netherlands', code: 'NL'},
  {name: 'New Zealand', code: 'NZ'},
  {name: 'Nigeria', code: 'NG'},
  {name: 'Norway', code: 'NO'},
  {name: 'Pakistan', code: 'PK'},
  {name: 'Philippines', code: 'PH'},
  {name: 'Portugal', code: 'PT'},
  {name: 'Poland', code: 'PL'},
  {name: 'Romania', code: 'RO'},
  {name: 'Serbia', code: 'RS'},
  {name: 'Singapore', code: 'SG'},
  {name: 'Slovakia', code: 'SK'},
  {name: 'Slovenia', code: 'SI'},
  {name: 'South Africa', code: 'ZA'},
  {name: 'Spain', code: 'ES'},
  {name: 'Sri Lanka', code: 'LK'},
  {name: 'Sweden', code: 'SE'},
  {name: 'Switzerland', code: 'CH'},
  {name: 'Taiwan', code: 'TW'},
  {name: 'Thailand', code: 'TH'},
  {name: 'Turkey', code: 'TR'},
  {name: 'United Arab Emirates', code: 'AE'},
  {name: 'United Kingdom', code: 'GB'},
  {name: 'United States', code: 'US'},
  {name: 'Uruguay', code: 'UY'},
  {name: 'Vietnam', code: 'VN'},
] as const;

export const STRIPE_CONNECT_SUPPORTED_COUNTRY_CODES: string[] =
  STRIPE_CONNECT_SUPPORTED_COUNTRIES.map((country) => country.code);

export const STRIPE_CONNECT_BETA_COUNTRIES = [
  {name: 'Algeria', code: 'DZ'},
  {name: 'Angola', code: 'AO'},
  {name: 'Azerbaijan', code: 'AZ'},
  {name: 'Bangladesh', code: 'BD'},
  {name: 'Benin', code: 'BJ'},
  {name: 'Bhutan', code: 'BT'},
  {name: 'Botswana', code: 'BW'},
  {name: 'Brunei', code: 'BN'},
  {name: 'Gabon', code: 'GA'},
  {name: 'Kazakhstan', code: 'KZ'},
  {name: 'Laos', code: 'LA'},
  {name: 'Monaco', code: 'MC'},
  {name: 'Mozambique', code: 'MZ'},
  {name: 'Niger', code: 'NE'},
  {name: 'Pakistan', code: 'PK'},
  {name: 'San Marino', code: 'SM'},
];

export const STRIPE_CONNECT_BETA_COUNTRY_CODES: string[] =
  STRIPE_CONNECT_BETA_COUNTRIES.map((country) => country.code);
